// extracted by mini-css-extract-plugin
export default {"container":"bya-z","oos":"cya-z","selected":"dya-z","recommendedSize":"eya-z"};